Button = require 'components/common/button'
CollapsibleWithControls = require 'components/common/collapsible_with_controls'
EllipsizedText = require 'components/common/ellipsized_text'
MiniDSActions = require 'actions/mini_ds_actions'
mediator = require 'mediator'
DocumentProgressSelect = require 'components/mini_ds/document_progress_select'
QuestionsActions = require 'actions/questions_actions'
Router = require 'router'
{ useCoffeeCallback, useI18n, useCoffeeMemo } = require 'lib/react_utils'

MiniDocumentListItem = ({ data: doc, questionStatuses, documentType }) ->

  i18n = useI18n('mda:docs')

  handleEdit = useCoffeeCallback [], (doc) -> ->
    MiniDSActions.openCreateOrEditDialog doc

  handleDelete = useCoffeeCallback [doc], ->
    QuestionsActions.deleteQuestion doc.get '_id'

  handleDuplicate = useCoffeeCallback [doc], ->
    QuestionsActions.duplicateQuestion questionId: doc.get '_id'

  userAccessRights = mediator.user.getAccessRights()

  { controls, isAdmin } = useCoffeeMemo [doc, userAccessRights], ->
    isAdmin = _.contains userAccessRights, 'admin'
    controls = if isAdmin
      [
        name: 'edit'
        handler: handleEdit doc
      ,
        name: 'delete'
        handler: handleDelete
      ]
    else []
    { controls, isAdmin }

  currentUserEmail = useCoffeeMemo [], -> mediator.user.getEmail().toLowerCase()

  handleClick = useCoffeeCallback [doc], ->
    link = Router::routeForSubmodule 'mda-handouts', null, questionId: doc.get '_id'
    mediator.publish '!router:route', link

  <CollapsibleWithControls controls={controls}>
    <div className="question-text flex flex-row items-center">
      <div onClick={handleClick} className="pl-10 flex-grow cursor-pointer">
        <EllipsizedText height={40} text={doc.get('name') or ''} />
      </div>
      <div>
        <DocumentProgressSelect
          documentType={documentType}
          editable={isAdmin}
          documentId={doc.get '_id'}
          showLabel={false}
          withCompleted={false}
        />
      </div>
    </div>
  </CollapsibleWithControls>

MiniDocumentListItem.propTypes =
  data: PropTypes.instanceOf(Immutable.Map)
  documentType: PropTypes.string

module.exports =  MiniDocumentListItem
